<ion-label class="installer-title" color="dark">
  {{ titleKey() | translate }}
</ion-label>

@if (hasInstaller()) {
  <div class="installer-row">
    <span class="installer-label">
      {{ 'installation_installerName' | translate }}
    </span>
    <span class="installer-value">
      {{ installer()?.firstname }} {{ installer()?.lastname }}
    </span>
  </div>
  <div class="installer-row">
    <span class="installer-label">
      {{ 'installation_installerEmail' | translate }}
    </span>
    <span class="installer-value">{{ installer()?.email }}</span>
  </div>
  <div class="installer-row">
    <span class="installer-label">
      {{ 'installation_installerInvitationAccepted' | translate }}
    </span>
    <span class="installer-value">
      {{
        installer()?.confirmed
          ? ('general_yes' | translate)
          : ('general_no' | translate)
      }}
    </span>
  </div>
  @if (canDelete()) {
    <div class="installer-row installer-row-actions">
      <ion-button
        color="danger"
        size="small"
        class="panel-label-text ion-wrap ion-align-self-center"
        (click)="deleteInstaller.emit()"
      >
        <ion-label class="panel-label-text">
          <small>{{ 'installation_deleteInstaller' | translate }}</small>
        </ion-label>
      </ion-button>
    </div>
  }
} @else {
  <div class="installer-empty">
    {{ emptyKey() | translate }}
  </div>
  @if (canAdd()) {
    <div class="installer-row installer-row-actions">
      <ion-button
        color="primary"
        size="small"
        class="panel-label-text ion-wrap ion-align-self-center"
        (click)="addInstaller.emit(addSlot())"
      >
        <ion-label class="panel-label-text">
          <small>{{ 'installation_addInstaller' | translate }}</small>
        </ion-label>
      </ion-button>
    </div>
  }
}
